export const DEFAULT_FRONT_MODE = "legacy";
export const TEAM_PLAN_NAME = "Team";
export const CUSTOM_PLAN_NAME = "Custom";

export function isTeamOrCustomPlan(planDetails) {
  const name = planDetails?.planName;
  return name === TEAM_PLAN_NAME || name === CUSTOM_PLAN_NAME;
}

export function canUseFrontVoiceMode(planDetails) {
  return isTeamOrCustomPlan(planDetails);
}

export function normalizeFrontMode(frontMode) {
  return frontMode === "voice" ? "voice" : DEFAULT_FRONT_MODE;
}

export function getFrontModeForPlan(frontMode, planDetails) {
  const normalized = normalizeFrontMode(frontMode);
  if (normalized === "voice" && !canUseFrontVoiceMode(planDetails)) {
    return DEFAULT_FRONT_MODE;
  }
  return normalized;
}

export function readFrontSettingsFromChannelData(channelData) {
  if (!channelData) {
    return { frontMode: DEFAULT_FRONT_MODE };
  }

  return {
    frontMode: normalizeFrontMode(
      channelData.frontMode?.S ?? channelData.front_mode?.S
    ),
  };
}

export function getDefaultFrontChannelFields() {
  return { frontMode: DEFAULT_FRONT_MODE };
}
